import { render, staticRenderFns } from "./Etapa8.vue?vue&type=template&id=6dedb883&scoped=true"
import script from "./Etapa8.vue?vue&type=script&lang=js"
export * from "./Etapa8.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=6dedb883&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa8.vue?vue&type=style&index=1&id=6dedb883&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dedb883",
  null
  
)

export default component.exports